import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IGetHolidayPayload,
  ActionType,
  IGetHolidayResponse,
} from "models/dashboard/holidayList";
import { httpStatus } from "configs/httpStatus";
import { getHolidayList } from "services/dashboard";
import { handleSuccessAction, handleErrorAction } from "./holidayListActions";

function* holidayListSaga({ payload }: { payload: IGetHolidayPayload }) {
  try {
    const response: IGetHolidayResponse = yield call(getHolidayList, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetHolidayListWatcher() {
  yield takeLatest(ActionType.HOLIDAY_LIST as any, holidayListSaga);
}

export default [fork(onGetHolidayListWatcher)];
